import React from "react";
import Hero from "../components/Hero";
import ServicesSection from "../components/ServicesSection";
import AboutSection from "../components/AboutSection";
import Testimonials from "../components/Testimonials";
import WhyChoose from "../components/WhyChoose";
import ContactCTA from "../components/ContactCTA";

const HomePage = () => {
  return (
    <>
      <Hero />
      <ServicesSection />
      <AboutSection />
      <Testimonials />
      <WhyChoose />
      <ContactCTA />
    </>
  );
};

export default HomePage;
